import React from "react";
import PrivateRoute from "../components/PrivateRoute";
import { Routes, Route } from "react-router-dom";
import AdminClient from "./SuperAdmin/AdminClient";
import Utilisateurs from "./SuperAdmin/Utilisateurs";
import OperationsType from "./SuperAdmin/OperationsType";
import LabelsOperationsType from "./SuperAdmin/LabelsOperationsType";
import Preconisations from "./SuperAdmin/Preconisations";
import Years from "./SuperAdmin/Years";
import CommunicationTools from "./SuperAdmin/CommunicationTools";
import VisuelRapport from "./SuperAdmin/VisuelRapport";
import TypesPlv from "./SuperAdmin/operations/TypesPlv";
import ChallengesType from "./SuperAdmin/challenges/ChallengesType";
import Prestataires from "./SuperAdmin/Prestataires";
import ManualImports from "./SuperAdmin/ManualImports";
const AdminRoute = () => {
  return (
    <Routes>
      <Route
        path="/clients"
        element={
          <PrivateRoute roles={[1, 2]}>
            <AdminClient />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/rapport-visuel"
        element={
          <PrivateRoute roles={[1, 2]}>
            <VisuelRapport />
          </PrivateRoute>
        }
      ></Route>

      <Route
        path="/operations"
        element={
          <PrivateRoute roles={[1, 2]}>
            <OperationsType />
          </PrivateRoute>
        }
      ></Route>
        {/* <JC */}
        <Route
        path="/labels-operations"
        element={
          <PrivateRoute roles={[1, 2]}>
            <LabelsOperationsType />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/preconisations"
        element={
          <PrivateRoute roles={[1, 2]}>
            <Preconisations />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/imports-manuels"
        element={
          <PrivateRoute roles={[1, 2]}>
            <ManualImports />
          </PrivateRoute>
        }
      ></Route>
      {/* JC> */}
      <Route
        path="/challenges"
        element={
          <PrivateRoute roles={[1, 2]}>
            <ChallengesType />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/utilisateurs"
        element={
          <PrivateRoute roles={[1, 2]}>
            <Utilisateurs />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/annees"
        element={
          <PrivateRoute roles={[1, 2]}>
            <Years />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/plv"
        element={
          <PrivateRoute roles={[1, 2]}>
            <TypesPlv />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/communications"
        element={
          <PrivateRoute roles={[1, 2]}>
            <CommunicationTools />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/prestataires"
        element={
          <PrivateRoute roles={[1, 2]}>
            <Prestataires />
          </PrivateRoute>
        }
      ></Route>
    </Routes>
  );
};

export default AdminRoute;
